var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M974 224L974 252",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 974.5,
    cy: 219.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M969.987 219.19C969.987 215.283 973.288 212.117 977.358 212.117C977.943 212.117 978.511 212.184 979.056 212.308C977.742 211.48 976.187 211 974.519 211C969.814 211 966 214.806 966 219.5C966 224.194 969.814 228 974.519 228C976.814 228 978.895 227.093 980.427 225.62C979.492 226.032 978.454 226.263 977.358 226.263C973.288 226.263 969.987 223.096 969.987 219.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M983.402 218.6L983.37 216.146L981.535 217.719L979.304 217.056L980.112 219.337L978.765 221.381L981.1 221.218L982.499 223.144L983.133 220.763L985.345 219.909L983.402 218.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch2);
export default __webpack_public_path__ + "static/media/church_2.6fccb452a4ccc7e0d197a606165e137a.svg";
export { ForwardRef as ReactComponent };